import { render, staticRenderFns } from "./message-details-subject-preview-block.vue?vue&type=template&id=15419a4d&scoped=true"
import script from "./message-details-subject-preview-block.vue?vue&type=script&lang=js"
export * from "./message-details-subject-preview-block.vue?vue&type=script&lang=js"
import style0 from "./message-details-subject-preview-block.vue?vue&type=style&index=0&id=15419a4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15419a4d",
  null
  
)

export default component.exports